import { groq } from "next-sanity"

import { AppSettings } from "@/settings"

import { checkPermissions } from "../../shared/permissions/permissions"
import { DomainObjects, Operations } from "../../shared/permissions/permissionsConfig"

// Query to fetch order (cash) returns by order numbers
export const queryOrderReturnsByOrderNumbers = {
  async orderReturnsByOrderNumbers(_parent, args, context, _info) {
    const { orderNumbers, isCashReturn = false, cdn, lang } = args

    const config = AppSettings.sanityConfigByLang(lang)
    const client = context.sanityClient
    client.config({ ...config, useCdn: cdn })
    const { user } = context

    await checkPermissions({
      user,
      domainObject: DomainObjects.ORDERS,
      operation: Operations.READ,
    })

    let groqQueryObject = []
    const type = isCashReturn ? `_type=="orderCashReturn"` : `_type=="orderReturn"`
    const draftsFilter = `&& !(_id in path("drafts.**"))`

    orderNumbers.forEach((orderNumber) => {
      const tmp = `"orderReturn_${orderNumber}" : *[${type} ${draftsFilter} && ("${orderNumber}" in lineItems[].orderId) ]`
      groqQueryObject.push(tmp)
    })

    const sanityResponse = await client.fetch(groq`{ ${groqQueryObject?.join(",")} }`)

    if (!sanityResponse) return null

    const results = []
    Object.entries(sanityResponse).forEach(([_, resultList]) => {
      resultList.forEach((value) => {
        if (!results.some((result) => result._id === value._id)) {
          const tmp = {
            _id: value._id,
            customerNumber: value.customerNumber,
            returnItems: value.lineItems?.map((item) => {
              return {
                number: item.orderNumber,
                orderNumber: item.orderId,
                positionId: item.positionId,
                sku: item.sku,
                value: item.value,
              }
            }),
          }
          results.push(tmp)
        }
      })
    })

    return results
  },
}
